import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  Avatar,
  SelectChangeEvent,
} from '@mui/material';
import { useTenant } from '../contexts/TenantContext';

// Mock data for tenants - in a real app, this would come from an API
const mockTenants = [
  { id: 'acme-healthcare', name: 'Acme Healthcare', primaryColor: '#1976d2' },
  { id: 'sunrise-senior', name: 'Sunrise Senior Living', primaryColor: '#7b1fa2' },
  { id: 'maple-grove', name: 'Maple Grove Care', primaryColor: '#388e3c' },
  { id: 'oak-park', name: 'Oak Park Nursing Home', primaryColor: '#f57c00' },
];

const TenantSelector: React.FC = () => {
  const tenantContext = useTenant();

  const handleTenantChange = (event: SelectChangeEvent<string>) => {
    const tenantId = event.target.value as string;
    const selectedTenant = mockTenants.find(t => t.id === tenantId);
    
    if (selectedTenant && tenantContext) {
      const tenantData = {
        id: selectedTenant.id,
        name: selectedTenant.name,
        primaryColor: selectedTenant.primaryColor,
      };
      
      tenantContext.setTenant(tenantData);
      tenantContext.setCurrentTenantId(tenantId);
      localStorage.setItem('currentTenantId', tenantId);
    }
  };

  return (
    <Box sx={{ width: '100%', px: 2, py: 1 }}>
      <FormControl fullWidth size="small">
        <InputLabel id="tenant-select-label">Facility</InputLabel>
        <Select
          labelId="tenant-select-label"
          id="tenant-select"
          value={tenantContext.currentTenantId || ''}
          label="Facility"
          onChange={handleTenantChange}
        >
          {mockTenants.map((tenant) => (
            <MenuItem key={tenant.id} value={tenant.id}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Avatar 
                  sx={{ 
                    width: 24, 
                    height: 24, 
                    fontSize: '0.75rem',
                    bgcolor: tenant.primaryColor || '#1976d2',
                    mr: 1
                  }}
                >
                  {tenant.name.charAt(0)}
                </Avatar>
                <Typography>{tenant.name}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default TenantSelector;